/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_vol_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is a fluid ounce the same as a regular ounce?`)
};

const es_uc_vol_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Una onza de fluido es igual a una onza regular?`)
};

const de_uc_vol_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist eine Fluid Ounce dasselbe wie eine gewöhnliche Unze?`)
};

const nl_uc_vol_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is een vloeistof-ounce hetzelfde als een normale ounce?`)
};

const fr_uc_vol_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une once liquide est-elle la même qu'une once régulière ?`)
};

const it_uc_vol_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un'oncia fluida è la stessa di un'oncia normale?`)
};

const pt_br2_uc_vol_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma onça fluida é a mesma que uma onça comum?`)
};

const pt_uc_vol_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma onça fluida é o mesmo que uma onça regular?`)
};

const ja_uc_vol_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`液量オンスは通常のオンスと同じですか?`)
};

const zh_uc_vol_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_vol_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_vol_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_vol_faq3_q", locale)
	if (locale === "en") return en_uc_vol_faq3_q(inputs)
	if (locale === "es") return es_uc_vol_faq3_q(inputs)
	if (locale === "de") return de_uc_vol_faq3_q(inputs)
	if (locale === "nl") return nl_uc_vol_faq3_q(inputs)
	if (locale === "fr") return fr_uc_vol_faq3_q(inputs)
	if (locale === "it") return it_uc_vol_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_vol_faq3_q(inputs)
	if (locale === "pt") return pt_uc_vol_faq3_q(inputs)
	if (locale === "ja") return ja_uc_vol_faq3_q(inputs)
	return zh_uc_vol_faq3_q(inputs)
};